import { createAction } from '../../utils/redux'
import { ActionsUnion } from '../../utils/types'

// actions
export const CLEAR = 'session/CLEAR'
export const SET = 'session/SET'
export const RESTORE = 'session/RESTORE'

export const DEFAULT_STATE = null

// action creators
// export const

// export const clearSession = () => {
//   return { type: CLEAR }
// }

export const SessionActions = {
  // setAppConfig: (config: JsonConfig) => createAction(SET, { config }),
  setSession: (session: any) => createAction(SET, { session }),
  clearSession: () => createAction(CLEAR),
  restoreSession: () => createAction(RESTORE)
  // console.log('SET session', session)
  // return { session, type: SET }
}

export type SessionActions = ActionsUnion<typeof SessionActions>
